import React from 'react';

interface FormProps {
	onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void;
	children?: React.ReactNode;
	className?: string;
}

export const Form = ({
	onSubmit,
	children = null,
	className = '',
}: FormProps) => {
	const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		onSubmit?.(event);
	};

	return (
		<form className={`styled-form ${className}`} onSubmit={handleSubmit}>
			{children}
		</form>
	);
};
